<div class="see-all">
  <a class="link" [routerLink]="url" [queryParams]="queryParams">
    <span class="text" [attr.data-automation-id]="seeAllType">
      <ng-content></ng-content>
      <fa-icon class="arrow-icon" [icon]="arrowIconRight"></fa-icon>
    </span>
  </a>
</div>
